import React from 'react';
import { Quote } from 'lucide-react';
export function InMemoriam() {
  return <section className="py-20 bg-stone-900 text-white relative overflow-hidden" data-id="element-275">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/wood-pattern.png')]" data-id="element-276"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-277">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-278">
          <div className="w-full md:w-1/3" data-id="element-279">
            <div className="relative" data-id="element-280">
              <div className="absolute inset-0 bg-amber-600 rounded-full blur-2xl opacity-20" data-id="element-281"></div>
              <div className="relative aspect-[3/4] w-full max-w-sm mx-auto overflow-hidden rounded-xl border-4 border-stone-700 shadow-2xl bg-stone-800" data-id="element-282">
                {/* Placeholder for Jeremiah's photo */}
                <div className="w-full h-full flex flex-col items-center justify-center bg-stone-800 text-stone-500 p-8 text-center" data-id="element-283">
                  <span className="text-6xl mb-4" data-id="element-284">✝</span>
                  <p data-id="element-285">Photo of Jeremiah Kiboya</p>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-286">
            <div className="inline-block px-3 py-1 bg-amber-900/50 border border-amber-700/50 rounded-full text-amber-400 text-sm font-medium mb-6" data-id="element-287">
              In Loving Memory
            </div>
            <h2 className="text-4xl md:text-5xl font-serif text-white mb-2" data-id="element-288">
              Jeremiah Kiboya
            </h2>
            <p className="text-xl text-stone-400 mb-8 italic" data-id="element-289">
              The Visionary Founder of GreenSlopes Farm
            </p>

            <div className="relative" data-id="element-290">
              <Quote className="absolute -top-4 -left-4 h-12 w-12 text-stone-700 opacity-50 transform -scale-x-100" data-id="element-291" />
              <p className="text-lg md:text-xl text-stone-300 leading-relaxed mb-8 pl-6" data-id="element-292">
                His foresight in acquiring this land and his dedication to
                farming laid the foundation for everything we are today. He
                taught us that the land rewards those who treat it with respect
                and hard work. Though he is gone, his spirit lives on in every
                harvest and every new calf born on this farm.
              </p>
            </div>

            <div className="h-px w-full bg-gradient-to-r from-transparent via-stone-700 to-transparent" data-id="element-293"></div>
          </div>
        </div>
      </div>
    </section>;
}